export enum FALLBACKCURRENCY {
    USD = 'USD',
}

export enum LOCALES {
    EN_US = 'en-US',
}

export enum LANGUAGE {
    EN = 'en',
}
